import { ITEMS_RARITY, ItemTemplate } from "../constants";

export default {
    type: "gold_coin_packs",
    listData: [{
        "key": "name",
        "label": "Name",
    }, {
        "key": "rarity",
        "label": "Rarity",
    }, {
        "key": "amount",
        "label": "Amount",
    }],
    template: [{
        "key": "name",
        "label": "Name",
        "type": "input",
    }, {
        "key": "game_id",
        "label": "Game Id",
        "type": "input",
        "format": "integer"
    }, {
        "key": "amount",
        "label": "Pack amount",
        "type": "input",
        "format": "integer"
    }, {
        "key": "rarity",
        "label": "Rarity",
        "type": "select",
        "values": ITEMS_RARITY
    }]
} as ItemTemplate;
